import { getEventGroup, ReportEvent, ReportEventGroup } from '@larva.io/report-definitions';

export default class ReportCodesHelpers {
  public static isUserEvent(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.SECURITY_ARMED_DISARMED:
      case ReportEvent.SECURITY_FAILED_TO_ARM:
      case ReportEvent.SECURITY_FAILED_TO_DISARM:
      case ReportEvent.SECURITY_PARTIAL_ARMED_DISARMED:
      case ReportEvent.SECURITY_TROUBLE_ACK:
      case ReportEvent.USER_ADDED:
      case ReportEvent.USER_REMOVED:
      case ReportEvent.USER_MODIFIED:
        ret = true;
        break;
    }
    switch (getEventGroup(code)) {
      case ReportEventGroup.DOOR_EVENTS:
      case ReportEventGroup.AUTHORIZATION_EVENTS:
        ret = true;
        break;
    }
    return ret;
  }

  public static isCloudEvent(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.CLOUD_EVENTS:
      case ReportEvent.CLOUD_SETTINGS_CHANGED:
      case ReportEvent.CLOUD_CONNECTION_CLOSED:
      case ReportEvent.CLOUD_CONNECTION_ERROR:
      case ReportEvent.CLOUD_CONFIGURATION_MISSING:
      case ReportEvent.CLOUD_CONNECTION_OFFLINE:
      case ReportEvent.CLOUD_TOKEN_PUBLIC_KEYS_URL_CHANGED:
      case ReportEvent.REMOTE_REPORTING_SETTINGS_CHANGED:
        ret = true;
        break;
    }
    return ret;
  }

  public static isSystemEvent(code: number) {
    let ret = false;
    switch (getEventGroup(code)) {
      case ReportEventGroup.SYSTEM_EVENTS:
      case ReportEventGroup.GENERIC_FLOW_EVENTS:
      case ReportEventGroup.INVALID:
      case ReportEventGroup.UNKNOWN_EVENTS:
        ret = true;
        break;
    }
    return ret;
  }
  public static isSecurityEvent(code: number) {
    return getEventGroup(code) === ReportEventGroup.SECURITY_EVENTS;
  }

  public static isFireAlarm(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.SECURITY_FIRE_ALARM:
      case ReportEvent.SECURITY_SMOKE_ALARM:
      case ReportEvent.SECURITY_COMBUSTION_ALARM:
      case ReportEvent.SECURITY_GAS_DETECTED:
      case ReportEvent.SECURITY_LOW_BOTTLED_GAS_LEVEL:
      case ReportEvent.SECURITY_CARBON_MONOXIDE_DETECTED:
        ret = true;
        break;
    }
    return ret;
  }

  public static isMedicalAlarm(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.SECURITY_MEDICAL_ALARM:
      case ReportEvent.SECURITY_PERSONAL_EMERGENCY:
      case ReportEvent.SECURITY_FAIL_TO_REPORT_IN:
        ret = true;
        break;
    }
    return ret;
  }

  public static isPanicAlarm(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.SECURITY_PANIC_ALARM:
      case ReportEvent.SECURITY_DURESS_PANIC_ALARM:
      case ReportEvent.SECURITY_SILENT_PANIC_ALARM:
      case ReportEvent.SECURITY_AUDIBLE_PANIC_ALARM:
      case ReportEvent.SECURITY_DURESS_ACCESS_GRANTED_ALARM:
      case ReportEvent.SECURITY_DURESS_EGRESS_GRANTED_ALARM:
        ret = true;
        break;
    }
    return ret;
  }

  public static isOtherAreaAlarm(code: number) {
    let ret = false;
    switch(code) {
      case ReportEvent.SECURITY_24_HOUR_NON_BURGLARY:
      case ReportEvent.SECURITY_REFRIGERATION:
      case ReportEvent.SECURITY_LOSS_OF_HEAT:
      case ReportEvent.SECURITY_WATER_LEAKAGE:
      case ReportEvent.SECURITY_FOIL_BREAK:
      case ReportEvent.SECURITY_HIGH_TEMP:
      case ReportEvent.SECURITY_LOW_TEMP:
      case ReportEvent.SECURITY_LOSS_OF_AIR_FLOW:
      case ReportEvent.SECURITY_TANK_LEVEL:
        ret = true;
        break;
    }
    return ret;
  }
}